<!-- zeige Anzahl der Mängel eines Kunden -->
<template>

  <span>

    <b-icon icon="arrow-clockwise" animation="spin" v-if="showOverlay" />

    <span class="anzahlMaengelIcon" v-if="showMangelIcon" @click="showMaengelliste">
        <b-avatar variant="warning"
                  v-b-tooltip.hover.top
                  :title="hovertitle"
                  v-if="anzahlMaengel > 0"
                  :text="'' + anzahlMaengel"
                  size="1.6rem">
        </b-avatar>
    </span>

  </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true

    export default {
        name: 'AnzahlMaengelIcon',
        props: {
            /** Anzahl der Mängel */
            anzahl: {
              type: Number,
              required: false,
            },
            /** oder alternativ der Kunde - dabei wird die Anzahl vom DataBroker gelesen */
            customer: {
              type: Object,
              required: false,
            }
        },
        data () {
            return {
              /** prüfen ob die Mängel angezeigt werden dürfen aus den Benutzerrechten des Kunden */
              showMaengelAllowed: true,
              anzahlMaengel: 0,
              showOverlay: null,
              hovertitle: '',
            }
        },
        watch: {

          customer: function () {
            this.init()
          },
          anzahl: function () {
            this.init()
          }

        },
        mounted: function () {
          this.init()
        },
        computed: {

          showMangelIcon: function () {

            if (!this.anzahlMaengel) return false
            return this.showMaengelAllowed

          }

        },
        methods: {

          init: function () {

            if (this.anzahl != null) {

              this.anzahlMaengel = this.anzahl
              this.hovertitle    = this.anzahlMaengel + ' ' + this.$t('message.anzahlMaengel')

            } else if (this.customer) {

              // prüfe ob die Anzahl bereits im Customer gecacht ist
              if (this.customer.anzahlOffeneMaengel != null) {
                this.anzahlMaengel = this.customer.anzahlOffeneMaengel
                this.hovertitle    = this.anzahlMaengel + ' ' + this.$t('message.anzahlMaengel')
                return
              }

              this.hovertitle = this.$t('message.anzahlMaengelIcon_hover')

              this.showOverlay   = true
              this.anzahlMaengel = this.anzahl

              // hole die Benutzerrechte des Customer um zu prüfen ob die Mängel angezeigt werden können
              const serverUrl = process.env.VUE_APP_SERVER_URL
              let url         =  serverUrl + '/biotechUser/getBenutzerrechte'
              const mandant   = typeof this.customer.biotechCountry === "string" ? this.customer.biotechCountry : this.customer.biotechCountry.name
              let params      = {
                cardcode:         this.customer.cardcode,
                mandant:          mandant,
                biotechUser_id:   this.$store.getters.user.id,
              }
              const that = this
              axios({
                method: 'GET',
                params: params,
                url: url,
              }).then(function (response) {

                if (response.data && response.data.id && response.data.showMaengel === false) {
                  that.showMaengelAllowed = false
                } else {

                  // wenn keine Anzahl übergeben wurde, dann hole sie:
                  if (that.anzahlMaengel == null) {

                    url     = serverUrl + '/datenbroker/countMaengel'
                    params  = {
                      customer: JSON.stringify(that.customer),
                    }
                    axios({
                      method: 'get',
                      params: params,
                      url: url,
                    }).then((response) => {
                      if (response.data && response.data.anzahl) {
                        that.anzahlMaengel = response.data.anzahl
                        console.log('Anzahl Maengel des Kunden: ' + that.anzahlMaengel)
                        that.emitAnzahl()
                      }
                    })

                  } else {
                    // wenn kein Plan hochgeladen wurde, hat der Kunde einen zusätzlichen Mangel:
                    that.countPlaene()
                  }

                }

                that.showOverlay = false

              })

            }

          },
          /**
           * wenn kein Plan hochgeladen wurde, hat der Kunde einen zusätzlichen Mangel:
           */
          countPlaene: function () {

            const that    = this
            const url     = process.env.VUE_APP_SERVER_URL + '/plan/countPlaene'
            const params  = {
              customer: JSON.stringify(this.customer),
            }
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then((response) => {
              if (response.data && response.data.anzahl < 1) {
                if (that.anzahlMaengel == null) that.anzahlMaengel = 0
                that.anzahlMaengel = that.anzahlMaengel + 1
              }
              that.emitAnzahl()
            })

          },
          /** Anzahl an Parent zurückliefern */
          emitAnzahl: function () {

            const obj = {
              customer: this.customer,
              anzahl:   this.anzahlMaengel,
            }
            this.$emit('set-anzahl-maengel', obj)

          },
          /** Mängelliste anzeigen */
          showMaengelliste: function () {

            if (this.customer) {
              this.setCustomerAndUserRights(this.customer)
              this.$router.push('/Maengelliste')
            }

          }

        }

    }

</script>

<style scoped>
    .anzahlMaengelIcon {
        cursor: pointer
    }
</style>
